import { useState, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import SearchWithAPI from "../../common/searchbox/searchbox.js";
import ModalCloseIcon from "../../../Assets/svg/close-modal.svg";
import ticketLogo from "../../../Assets/svg/ticket_icon.svg";
import { apiCall } from "../../../services/api-service.js";

const AssignTicketModal = ({ ticketDetail, onHide, onSuccess }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [selectedAssignee, setSelectedAssignee] = useState(null);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [notes, setNotes] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (ticketDetail) {
      if (ticketDetail.assign_to_id) {
        setSelectedAssignee({ value: ticketDetail.assign_to_id, label: ticketDetail.assigned_to });
      }
      if (ticketDetail.team_id) {
        setSelectedTeam({ value: ticketDetail.team_id, label: ticketDetail.team });
      }
    }
  }, [ticketDetail]);

  const handleAssign = async () => {
    let newErrors = {};
    if (!selectedAssignee) newErrors.assign_to = "Please select an assignee";
    if (!selectedTeam) newErrors.team = "Please select a team";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setLoading(true);
    const payload = {
      id: ticketDetail.id,
      assign_to: selectedAssignee.value,
      team_id: selectedTeam?.value || null,
      remarks: notes,
    };

    try {
      const response = await apiCall("put", "ticket/update_assign_to", payload);
      if (response?.data?.success) {
        onSuccess();
      } else {
        setErrors(response?.data?.error || { message: response?.data?.message });
      }
    } catch (error) {
      console.error("Assign Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",
      borderRadius: "24px",
      width: "520px",
      padding: "24px",
      boxShadow: "0 12px 40px rgba(0, 0, 0, 0.15)",
    },
  };

  return (
    <div style={modalStyle.overlay} onClick={onHide}>
      <div style={modalStyle.modal} onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 style={{ fontSize: "24px", fontWeight: "700", color: "#212129", margin: 0 }}>Assign ticket</h2>
          <div
            onClick={onHide}
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              border: "1px solid #EBEBEB",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
          >
            <img src={ModalCloseIcon} alt="close" style={{ width: "14px" }} />
          </div>
        </div>

        {/* Ticket Info Card */}
        <div
          style={{
            background: "#F7F8F9",
            borderRadius: "16px",
            padding: "16px",
            display: "flex",
            gap: "16px",
            alignItems: "flex-start",
            marginBottom: "24px",
          }}
        >
          <div
            style={{
              width: "40px",
              height: "40px",
              background: "#ffff",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <img src={ticketLogo} alt="ticket" style={{ width: "20px" }} />
          </div>
          <div style={{ overflow: "hidden" }}>
            <h3
              style={{
                fontSize: "16px",
                fontWeight: "600",
                color: "#212129",
                marginBottom: "4px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {ticketDetail.code} - {ticketDetail.title}
            </h3>
            <div className="d-flex align-items-center gap-2">
              <span style={{ fontSize: "14px", color: "#8790A1" }}>{ticketDetail.project || "No Project"}</span>
              <span style={{ width: "4px", height: "4px", background: "#D9D9D9", borderRadius: "50%" }}></span>
              <span style={{ fontSize: "14px", color: "#6929E2", fontWeight: "500" }}>{ticketDetail.status}</span>
            </div>
          </div>
        </div>

        {/* Form Fields */}
        <div className="mb-3">
          <label style={{ fontSize: "14px", fontWeight: "600", color: "#212129", marginBottom: "8px", display: "block" }}>
            Assign to <span style={{ color: "red" }}>*</span>
          </label>
          <SearchWithAPI
            onDropdownChange={(opt) => {
              setSelectedAssignee(opt);
              setErrors((prev) => ({ ...prev, assign_to: "" }));
            }}
            apiUrl={`get_employee`}
            params={{ team_id: selectedTeam?.value || "" }}
            placeholder="Select Employee"
            selectedValue={selectedAssignee?.label || ""}
            selectedOption={selectedAssignee}
          />
          {errors.assign_to && <span style={{ color: "#F44336", fontSize: "12px", marginTop: "4px", display: "block" }}>{errors.assign_to}</span>}
        </div>

        <div className="mb-3">
          <label style={{ fontSize: "14px", fontWeight: "600", color: "#212129", marginBottom: "8px", display: "block" }}>
            Team <span style={{ color: "red" }}>*</span>
          </label>
          <SearchWithAPI
            onDropdownChange={(opt) => {
              setSelectedTeam(opt);
              setErrors((prev) => ({ ...prev, team: "" }));
            }}
            apiUrl={`get_team`}
            placeholder="Select Team"
            selectedValue={selectedTeam?.label || ""}
            selectedOption={selectedTeam}
          />
          {errors.team && <span style={{ color: "#F44336", fontSize: "12px", marginTop: "4px", display: "block" }}>{errors.team}</span>}
        </div>

        <div className="mb-4">
          <label style={{ fontSize: "14px", fontWeight: "600", color: "#212129", marginBottom: "8px", display: "block" }}>Notes (Optional)</label>
          <textarea
            placeholder="Enter here..."
            className="form-control"
            rows={4}
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            style={{
              borderRadius: "12px",
              border: "1px solid #EBEBEB",
              padding: "12px",
              fontSize: "14px",
              resize: "none",
            }}
          />
        </div>

        {/* Actions */}
        <div className="d-flex justify-content-end gap-3">
          <button
            onClick={onHide}
            style={{
              padding: "12px 32px",
              borderRadius: "100px",
              border: "1px solid #EBEBEB",
              background: "#FFFFFF",
              fontSize: "16px",
              fontWeight: "700",
              color: "#212129",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleAssign}
            disabled={loading}
            style={{
              padding: "12px 32px",
              borderRadius: "100px",
              border: "none",
              background: "#6929E2",
              fontSize: "16px",
              fontWeight: "700",
              color: "#FFFFFF",
              cursor: "pointer",
              minWidth: "120px",
              opacity: loading ? 0.7 : 1,
            }}
          >
            {loading ? <Spinner animation="border" size="sm" variant="light" /> : "Assign"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssignTicketModal;
